var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.type)?_c('div',{staticClass:"box"},_vm._l((4),function(item,index){return _c('span',{key:index})}),0):_c('div',{staticClass:"box3"},[_c('div',{staticClass:"box2"}),_c('img',{attrs:{"src":require("../assets/new_img/b1.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }